import React from 'react';

export enum ServiceType {
	AsistenciaCarretera = 'asistencia-carretera',
	LongDrive = 'long-drive',
	GarantiaVolkswagen = 'garantia-volkswagen',
	IdCare = 'id-care',
	RecogidaEntrega = 'recogida-entrega',
	CocheSustitucion = 'coche-sustitucion',
	ExpressService = 'express-service',
	Autoservicio = 'autoservicio',
	ITVporTi = 'itv-por-ti',
	CheckeoCortesia = 'checkeo-cortesia',
	PreItv = 'pre-itv',
}

export enum ServiceGroupType {
	Coberturas = 'Coberturas',
	Dealer = 'Dealer',
	default = 'default',
}

export interface ServiceLayer {
	id: ServiceGroupType;
	header: string;
	title: string;
	subtitle: JSX.Element;
	description?: JSX.Element;
	imageContent?: string;
	ctaText?: string;
	link?: string;
	descriptionFooter?: JSX.Element;
	imageFooter?: string;
}

export const defaultServiceLayer: ServiceLayer = {
	id: ServiceGroupType.default,
	header: '',
	title: '',
	subtitle: <></>,
	description: <></>,
};
